<div mat-dialog-title>
  <span>{{ title }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content [ngStyle]="{width: dialogWidth}" class="confirm-delete-content">
  <p>{{ message }}</p>
  <p *ngIf="additionalMessage">{{ additionalMessage }}</p>
  <q9-info-message *ngIf="warningMessage" type="warn">* {{ warningMessage }}</q9-info-message>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button color="warn" (click)="cancel()">
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button color="warn" (click)="confirm()">
    {{ confirmButtonText }}
  </q9-primary-button>
</mat-dialog-actions>
